var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 16,
  viewBox: "0 0 12 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.912 0A5.919 5.919 0 0 0 0 5.912c0 3.156 5.39 9.675 5.62 9.95a.381.381 0 0 0 .585 0c.23-.275 5.62-6.794 5.62-9.95A5.919 5.919 0 0 0 5.912 0Zm0 15.014a53.39 53.39 0 0 1-2.453-3.321C1.694 9.083.762 7.084.762 5.913c0-2.84 2.31-5.151 5.15-5.151 2.84 0 5.15 2.31 5.15 5.15 0 1.172-.932 3.171-2.696 5.78a53.412 53.412 0 0 1-2.454 3.322Z",
  fill: "#3B3B3B"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.912 2.92a3.127 3.127 0 0 0-3.124 3.124 3.127 3.127 0 0 0 3.124 3.124 3.127 3.127 0 0 0 3.124-3.124 3.127 3.127 0 0 0-3.124-3.123Zm0 5.486A2.365 2.365 0 0 1 3.55 6.044a2.365 2.365 0 0 1 2.362-2.361 2.365 2.365 0 0 1 2.362 2.361 2.365 2.365 0 0 1-2.362 2.362Z",
  fill: "#3B3B3B"
})));
export default SvgPin;